import { Popover } from 'antd'
import { WarningFilled } from '@ant-design/icons'
import React from 'react'
import './invalid-connection-label.scss'

type InvalidConnectionLabelProps = {
    content?: React.ReactNode
}

export const InvalidJourneyComponent = ({ content }: InvalidConnectionLabelProps) => {
    return (
        <Popover
            overlayClassName="invalid-label-popover"
            className="nodrag nopan"
            content={content || 'Invalid connection'}
        >
            <WarningFilled />
        </Popover>
    )
}
